import { greyA100, grey600, grey900, lightBlue900 } from './colors';

const hotels = {
  filters: {
    expandoIcon: lightBlue900,
    border: greyA100,
    search: greyA100,
    text: grey900,
    count: grey600,
  },
};

export default hotels;
